import EFPicture from 'elem/compCommon/EFPicture';
import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import gtm from '@/utils/gtm';

export default function C() {
    const { useLang } = useGlobal();
    const { t } = useLang('amazonsale');
    const [copy, setCopy] = useState(false);
    const code = 'EF2024DE';

    const copyToClipboard = (text: string) => {
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(text);
        } else {
            const textarea = document.createElement('textarea');
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        }
    };

    const onCopy = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'copy_promo_code',
            title_name: t('sectionC_title'),
            button_name: t('sectionC_btn'),
            position: 'Productdetails',
        });
        copyToClipboard(code);
        setCopy(true);
    };

    return (
        <div id="amazon-sale-C" className={`amazon-sale-C ${css['amazon-sale-C']}`}>
            <div className="section-content">
                <p className="title">{t('sectionC_title')}</p>
                <div className="code-content">
                    <EFPicture
                        src="https://websiteoss.ecoflow.com/upload/image/1724377664444/amazon_sale_c_pc.png"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1724377664274/amazon_sale_c_h5.png"
                        alt={t('sectionC_title')}
                    />
                    <p className="code">{code}</p>
                    <button className={`btn ${copy ? 'copy' : ''}`} onClick={onCopy}>
                        {copy ? t('sectionC_btn2') : t('sectionC_btn')}
                    </button>
                </div>
                <p className="tips">{t('sectionC_tips')}</p>
            </div>
        </div>
    );
}
